import { MessagesInterface } from '../../../general/model';
import { CHNode } from '../../../general/node';

export enum Step {
  NONE = 'NONE',
  WELCOME = 'WELCOME',
  SELECTION = 'SELECTION',
  LINK = 'LINK',
  EMAIL = 'EMAIL',
  FINISH = 'FINISH',
}

export type SharingShape = {
  isExpanded: boolean;
  isEnabled: boolean;
  selectedNodes: CHNode[];
  expiresIn: string;
  doesNotExpire: boolean;
  name: string;
  shareLink: string;
  isShareLinkLoading: boolean;
  lastNodeIDSelected: null | number;
  firstNodeIDSelected: null | number;
};

export const initialState: SharingShape = {
  isExpanded: false,
  isEnabled: false,
  selectedNodes: [],
  expiresIn: '30',
  name: '',
  shareLink: '',
  doesNotExpire: false,
  isShareLinkLoading: false,
  lastNodeIDSelected: null,
  firstNodeIDSelected: null,
};

export const expiresValid = (val: string) => {
  const parsed = parseInt(val, 10);
  return !(isNaN(parsed) || parsed < 0);
};

export const validateExpiresIn = (newValue: string, oldValue: string): string => {
  if (newValue === '') return ''; // allow empty textbox
  return expiresValid(newValue) ? newValue : oldValue;
};

export const validateName = (newValue: string, strict: boolean): string => {
  if (!strict) return newValue;
  return newValue.trim();
};

export const Messages = {
  createShareError: () => ({
    title: `Server request error`,
    message: `Failed to create share`,
  }),
  createShareSuccess: () => ({
    title: `Share has been created`,
  }),
  linkCopied: () => ({
    title: `Share link copied to clipboard`,
  }),
} as MessagesInterface;
